import { errorPageTexts } from '../common/texts'

export function ErrorPage() {
  return (
    <div className="flex flex-column align-items-center justify-content-center min-h-screen">
      <h1>{errorPageTexts.title}</h1>
      <p>{errorPageTexts.message}</p>
    </div>
  )
}
